export default "__VITE_ASSET__CABecxLM__"